// 公共下载地址
export const DOWNLOAD_URL = 'https://app.iqilu.com/download/jump'

// 临沂下载地址
export const DOWNLOAD_URL_LY = 'https://12345.linyi.gov.cn/download/index.html'

// 闪电新闻下载地址IOS
export const DOWNLOAD_URL_SD_NEWS_IOS = `https://ksdshare.iqilu.com/share/download/?entry=${encodeURIComponent(
  JSON.stringify({ opentype: 'webapp', param: `${location.href}` })
)}`

// 闪电新闻下载地址安卓
export const DOWNLOAD_URL_SD_NEWS_ANDROID = `https://a.app.qq.com/o/simple.jsp?pkgname=com.iqilu.ksd&ckey=&android_schema=${encodeURIComponent(
  `sdxw://platformapi/startapp?entry=${encodeURIComponent(
    JSON.stringify({ opentype: 'webapp', param: `${location.href}` })
  )}`
)}`

// 样式主题 无主题3 通用2 党建3
export const THEME_TYPE_NONE = 3
export const THEME_TYPE_COMMON = 2
export const THEME_TYPE_PARTY = 1

